import {
  DELETE_SHIPPING_PROVIDER,
  INSERT_SHIPPING_PROVIDER
} from 'graphql/mutations/integrations';
import * as Yup from 'yup';

const cobraData = {
  key: 'COBRA',
  label: 'BEETRACK',
  createMutation: INSERT_SHIPPING_PROVIDER,
  deleteMutation: DELETE_SHIPPING_PROVIDER,
  noDisplayFields: [
    { name: 'clientId', path: 'clientId' },
    { name: 'providerId', path: 'id' }
  ],
  getMixedTypes: (params) => {
    return {
      service: () => {
        const notAvailableItems = params?.integrationsData?.map(
          (item) => item.service
        );

        return ['NACIONAL', 'PROGRAMADO', 'EXPRESS'].filter(
          (item) => !notAvailableItems?.includes(item)
        );
      }
    };
  },
  fields: [
    {
      title: 'Alias',
      label: 'Ej. Primera integración',
      keyName: 'alias',
      type: '',
      initialValue: '',
      helperText: 'Introduce un nombre para identificar esta integración',
      validationSchema: Yup.string().required('Ingresa el campo Alias')
    },
    {
      title: 'Servicio',
      label: 'Ej. PROGRAMADO',
      keyName: 'service',
      type: [],
      initialValue: '',
      helperText: 'Introduce el tipo de servicio',
      validationSchema: Yup.string().required('Ingresa el campo SERVICIO')
    },
    {
      label: 'Metadata',
      keyName: 'metadata',
      type: {},
      fields: [
        {
          title: 'BUSINESS ID',
          label: 'Ej: business_id_example',
          keyName: 'businessId',
          type: '',
          initialValue: '',
          helperText: 'Introduce tu BUSINESS ID',
          validationSchema: Yup.string().required(
            'Ingresa el campo BUSINESS ID'
          )
        }
      ]
    }
  ]
};

export default cobraData;
